import { useEffect, useRef, useState } from 'react'
import { POLL_AI_ARTWORKS } from '~/graphqls/gqls'
import {
  AiArtWorkStatus,
  pollAIArtWorks,
  pollAIArtWorksVariables,
} from '~/graphqls/types'
import { useImperativeQuery } from '~/hooks/useImperativeQuery'
import { deepCopy } from '~/utils'

export default function useUpdateList<
  T extends { status: AiArtWorkStatus; id: any }
>(list: T[]) {
  const timerRef = useRef(0)
  const [progressCache, setProgressCache] = useState<Record<any, T>>({})
  const pollProductsAction = useImperativeQuery<
    pollAIArtWorks,
    pollAIArtWorksVariables
  >(POLL_AI_ARTWORKS)
  /** 待轮询的id列表 */
  const idListRef = useRef<number[]>([])

  const updateData = async () => {
    let nextTick = 30 * 1000

    try {
      const res = await pollProductsAction({ ids: idListRef.current })
      const list = res.data.pictureGraph?.aiArtworksGeneratingInfo?.list || []

      /** 临时数据 */
      const _progressCache = deepCopy(progressCache)

      list?.forEach(item => {
        _progressCache[item?.id] = item
      })

      setProgressCache(_progressCache)

      nextTick =
        (res.data.pictureGraph?.aiArtworksGeneratingInfo?.nextPollingTime ||
          0) * 1000
    } catch (err) {
      console.error(err)
    }

    /** nextPollingTime 返回0则表示都已经生成，不需要轮询 */
    if (!nextTick) return

    timerRef.current = window.setTimeout(updateData, nextTick)
  }
  useEffect(() => {
    window.clearTimeout(timerRef.current)

    idListRef.current = list
      .filter(item =>
        [AiArtWorkStatus.GENERATEING, AiArtWorkStatus.QUEUEING].includes(
          item.status
        )
      )
      .map(item => item.id)

    /** 没有生成中的直接返回 */
    if (!idListRef.current.length) return

    updateData()

    return () => window.clearTimeout(timerRef.current)
  }, [list])

  return progressCache
}
